import { AxiosResponse } from 'axios';
import React, { ChangeEvent, useState } from 'react';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  FormControlLabel,
  InputLabel,
  TextField
} from '@mui/material';
import CustomAlert, { CustomAlertType } from '../../../Components/CustomAlert';
import NftMoveRequest from '../../../Model/nftMoveRequest';
// eslint-disable-next-line import/no-extraneous-dependencies
import { LoadingButton } from '@mui/lab';
import { nftMove } from '../../../api/support';
import { useTranslation } from 'react-i18next';

const NftMove = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [clawback, setClawback] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorType, setErrorType] = useState<CustomAlertType>();
  const [newAccount, setNewAccount] = useState<string>('');
  const [oldAccount, setOldAccount] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);
  const [nftId, setNftId] = useState<string>();

  const { t } = useTranslation();

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;

    switch (field) {
      case 'oldAccount': {
        setOldAccount(value);
        break;
      }
      case 'newAccount': {
        setNewAccount(value);
        break;
      }
      case 'nftId': {
        setNftId(value);
        break;
      }
      case 'clawback': {
        setClawback(e.target.checked);
        break;
      }
      default:
        break;
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity()) {
      const submitData: NftMoveRequest = {
        oldAccount: oldAccount!,
        newAccount: newAccount!,
        allowClawback: clawback!
      };
      setLoading(true);

      try {
        const result: AxiosResponse = await nftMove(nftId!, submitData);
        setLoading(false);
        if (result.data.success) {
          setLoading(false);
          setShowError(true);
          setErrorMessage(t('SENSOR_ADDED'));
          setErrorType(CustomAlertType.INFO);
          form.reset();
        }
      } catch (error: any) {
        setLoading(false);
        setShowError(true);
        setErrorMessage(error.response.data.errorMessage);
        setErrorType(CustomAlertType.ALERT);
      }
    }
  };

  return (
    <Container>
      <Card sx={{ maxWidth: 600, padding: 0 }} style={{ margin: 'auto' }}>
        <CardHeader
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.125)' }}
          subheader={t('NFT_MOVE')}
        ></CardHeader>
        <Box
          sx={{
            width: 'auto',
            maxWidth: '100%'
          }}
        >
          <form onSubmit={handleSubmit}>
            <CardContent>
              <InputLabel>{t('NFT_ID')}</InputLabel>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                fullWidth
                id="nftId"
                value={nftId}
                onChange={onChangeValue}
              />
              <Box sx={{ height: 20 }} />
              <InputLabel>{t('OLD_ACCOUNT')}</InputLabel>
              <TextField
                fullWidth
                id="oldAccount"
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                value={oldAccount}
                onChange={onChangeValue}
              />
              <Box sx={{ height: 20 }} />
              <InputLabel>{t('NEW_ACCOUNT')}</InputLabel>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                fullWidth
                id="newAccount"
                value={newAccount}
                onChange={onChangeValue}
              />
              <FormControlLabel
                control={<Checkbox onChange={onChangeValue} id="clawback" />}
                label="Clawback"
              />
            </CardContent>
            <CardActions>
              <LoadingButton
                loading={loading}
                variant="contained"
                style={{
                  marginLeft: 'auto',
                  marginRight: 10,
                  marginBottom: 10
                }}
                type="submit"
              >
                {t('MOVE')}
              </LoadingButton>
            </CardActions>
          </form>
        </Box>
      </Card>
      <CustomAlert
        show={showError}
        message={errorMessage}
        type={errorType}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </Container>
  );
};

export default NftMove;
